import React, { useState } from 'react';
import { Play, Quote } from 'lucide-react';
import { REVIEWS } from '../lib/butterstone';

const ReviewsSection = () => {
  const [playing, setPlaying] = useState(null);
  return (
    <section id="reviews" className="section-pad bg-[#F6F5EF]" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <span className="overline center">Guest Stories</span>
          <h2 className="font-serif text-4xl md:text-6xl mt-4">Reviews from our guests</h2>
          <p className="text-[#5E6E60] mt-4 max-w-2xl mx-auto">Hear it straight from the people who stayed with us. Video reviews load from YouTube.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {REVIEWS.map((r, i) => (
            <div key={i} className="leaf-card overflow-hidden" data-testid={`review-${i}`}>
              <div className="relative aspect-video bg-[#1E3226]">
                {playing === i && r.youtubeId ? (
                  <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${r.youtubeId}?autoplay=1`} title={r.name} frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen />
                ) : (
                  <button className="group w-full h-full" onClick={() => r.youtubeId && setPlaying(i)}>
                    <img src={r.poster} alt={r.name} className="w-full h-full object-cover opacity-80" />
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform"><Play size={22} className="text-[#2F5233] ml-1" /></div>
                    </div>
                    {!r.youtubeId && <span className="absolute bottom-3 left-0 right-0 text-center text-white text-xs tracking-wider">Video coming soon</span>}
                  </button>
                )}
              </div>
              <div className="p-4">
                <Quote size={18} className="text-[#6E9A5E] mb-1" />
                <p className="font-medium text-[#1E3226]">{r.name}</p>
                <p className="text-sm text-[#5E6E60]">{r.place}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
